export interface UserProfile {
  id: string;
  username: string;
  tag: string; // e.g. #4892
  email: string;
  role: 'user' | 'admin';
  avatarUrl: string;
  avatarId?: string;  // DB avatar_id (e.g. 'av_3')
  qrCodeUrl?: string;
  duels_won?: number;
  win_streak?: number;
}

export const AVATARS_LIST = [
  { id: 'av_1', name: 'Nano Banana AI', icon: '🍌', color: '#eab308' },
  { id: 'av_2', name: 'Cyber Neon Cat', icon: '🐱', color: '#a855f7' },
  { id: 'av_3', name: 'Pixel Robot', icon: '🤖', color: '#38bdf8' },
  { id: 'av_4', name: 'Synthwave Samurai', icon: '🥷', color: '#ef4444' },
  { id: 'av_5', name: 'Space Astronaut', icon: '👨‍🚀', color: '#6366f1' },
  { id: 'av_6', name: 'Hologram Fox', icon: '🦊', color: '#f97316' },
  { id: 'av_7', name: '8-Bit Dragon', icon: '🐉', color: '#22c55e' },
  { id: 'av_8', name: 'Ninja Hacker', icon: '👤', color: '#64748b' },
  { id: 'av_9', name: 'Mech Suit', icon: '🦾', color: '#06b6d4' },
  { id: 'av_10', name: 'Pixel Wizard', icon: '🧙‍♂️', color: '#8b5cf6' },
  { id: 'av_11', name: 'Cosmic Bunny', icon: '🐰', color: '#ec4899' },
  { id: 'av_12', name: 'Galactic Knight', icon: '🛡️', color: '#3b82f6' },
  { id: 'av_13', name: 'Arcade Ghost', icon: '👻', color: '#14b8a6' },
  { id: 'av_14', name: 'Cyber Falcon', icon: '🦅', color: '#f59e0b' },
  { id: 'av_15', name: 'Quantum Bear', icon: '🐻', color: '#84cc16' },
];

export class AuthStore {
  private static user: UserProfile | null = null;
  private static listeners = new Set<(user: UserProfile | null) => void>();

  static setUser(user: UserProfile | null): void {
    this.user = user;
    if (user) {
      localStorage.setItem('arcade_user', JSON.stringify(user));
    } else {
      localStorage.removeItem('arcade_user');
    }
    this.listeners.forEach((fn) => fn(user));
  }

  static getUser(): UserProfile | null {
    if (!this.user && typeof localStorage !== 'undefined') {
      const saved = localStorage.getItem('arcade_user');
      if (saved) {
        try {
          this.user = JSON.parse(saved);
        } catch {
          this.user = null;
        }
      }
    }
    return this.user;
  }

  static updateAvatar(avatarUrl: string): void {
    const u = this.getUser();
    if (u) {
      u.avatarUrl = avatarUrl;
      this.setUser(u);
    }
  }

  static subscribe(fn: (user: UserProfile | null) => void): () => void {
    this.listeners.add(fn);
    return () => this.listeners.delete(fn);
  }

  static get isAuthenticated(): boolean {
    return !!this.getUser();
  }

  static get isAdmin(): boolean {
    const u = this.getUser();
    return u?.role === 'admin';
  }

  static generatePlayerTag(): string {
    return '#' + Math.floor(1000 + Math.random() * 9000).toString();
  }

  static checkGuestExpiration(): void {
    if (this.isAuthenticated) {
      localStorage.removeItem('arcade_guest_start');
      return;
    }
    const guestStart = localStorage.getItem('arcade_guest_start');
    if (!guestStart) {
      localStorage.setItem('arcade_guest_start', Date.now().toString());
    } else {
      const startMs = parseInt(guestStart, 10);
      const now = Date.now();
      const diffHours = (now - startMs) / (1000 * 60 * 60);
      if (diffHours >= 48) {
        localStorage.removeItem('arcade_achievements');
        localStorage.removeItem('arcade_scores');
        localStorage.removeItem('arcade_user');
        localStorage.setItem('arcade_guest_start', now.toString());
        console.log('Guest session expired after 48 hours. Progress reset.');
      }
    }
  }
}
